/**
 * @internal
 * @deprecated ConditionalWrapper was removed in @sanity/ui v4. Inline the conditional wrapping logic instead.
 */
export function ConditionalWrapper(_props?: never): never {
  throw new Error(
    '`ConditionalWrapper` was removed in @sanity/ui v4. Inline the conditional wrapping logic instead.',
  )
}
